import { render, staticRenderFns } from "./SpatialSpanWorkingMemoryTutorial.vue?vue&type=template&id=e050fa66&scoped=true&"
import script from "./SpatialSpanWorkingMemoryTutorial.vue?vue&type=script&lang=js&"
export * from "./SpatialSpanWorkingMemoryTutorial.vue?vue&type=script&lang=js&"
import style0 from "./SpatialSpanWorkingMemoryTutorial.vue?vue&type=style&index=0&id=e050fa66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e050fa66",
  null
  
)

export default component.exports